import { mapActions } from 'vuex';
import { $EventBus } from '@/main';
import { deleteContractDocument } from '@/store/modules/contract/service/contract.service';

export default {
	name: 'DeleteFileBtn',
	props: {
		value: {
			type: Boolean,
			required: false,
		},
		documentId: {
			type: [String, Number],
			required: false,
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	created() {},
	mounted() {},
	computed: {},
	watch: {},
	methods: {
		...mapActions('contract', ['deleteContract']),

		async removeContract() {
			const { isConfirmed } = await this.$swal.fire({
				title: '¿Estás seguro de que quieres eliminar?',
				text: '',
				icon: 'question',
				showCancelButton: true,
				cancelButtonColor: '#e0e0e0',
				confirmButtonColor: '#0039a6',
				cancelButtonText: 'No',
				confirmButtonText: 'Sí',
				reverseButtons: true,
			});
			if (isConfirmed) {
				this.sendDeletion();
			}
		},

		async sendDeletion() {
			try {
				this.loading = true;
				await deleteContractDocument(this.documentId);
				$EventBus.$emit('showSnack', 'success', 'Registro eliminado');
				this.$emit('update');
			} catch (error) {
				this.showError(error?.response || error.toString());
			} finally {
				this.loading = false;
			}
		},

		showError(error) {
			let msmError = error?.data?.message;
			if (msmError) {
				msmError = Array.isArray(msmError) ? msmError.join(', ') : msmError;
			} else {
				msmError = error;
			}
			$EventBus.$emit('showSnack', 'error', msmError);
		},
	},
	components: {},
};
